// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RaGv","toggle":"styles_toggle__2hXsF","preview":"styles_preview__3BiTo"};